export const renamingUIUsers = [
  'mars_test@algorithm',
  '42c1e28e-3bd5-4967-8153-87c25b424f54',
  '4dd5215d-fe92-4ea1-8c04-f9bc5a0528c4',
  'superadmin@silenthelium.com'
];

export const renamingUITaExact = ['All 25-45', 'All 25-54', 'Все 25-45 BC', 'Все 25-45 ВС', 'W 25-50'];
export const renamingUITaContains = [];
